<template>
  <v-dialog v-model="open" persistent max-width="720px">
    <v-card>
      <form @submit.prevent="!isProcessing ? onSubmit() : null">
        <v-card-title>
          <span class="headline">Dodawanie noty obciążeniowej</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0" grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm6>
                <v-text-field
                  label="Nr noty"
                  v-model="formData.number"
                  browser-autocomplete="off"
                  hint="Uzupełniany automatycznie"
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="issuedAtPicker"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    label="Data wystawienia"
                    slot="activator"
                    v-model="formData.issued_at"
                    readonly
                    v-validate="'required'"
                    data-vv-name="data wystawienia"
                    :error-messages="errors.collect('data wystawienia')"
                    browser-autocomplete="off">
                  </v-text-field>
                  <v-date-picker v-model="formData.issued_at"
                                 @input="issuedAtPicker = false; fetchMetaForDate()"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 class="display-flex align-items-center justify-content-between">
                <div class="subheading mb-1">Odbiorca</div>
                <v-btn small color="#555474" dark class="ma-0"
                       :loading="gusLoading"
                       @click="fetchFromGus">
                  <v-icon size="14px" class="mr-1">fas fa-cloud-download-alt</v-icon>
                  Pobierz z GUS
                </v-btn>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="Firma"
                  v-model="formData.recipient_company_name"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="NIP"
                  v-model="formData.recipient_nip"
                  v-validate="'digits:10'"
                  data-vv-name="NIP"
                  :error-messages="errors.collect('NIP')"
                  hint="Wpisz NIP i kliknij „Pobierz z GUS”"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="PESEL"
                  v-model="formData.recipient_pesel"
                  v-validate="'digits:11'"
                  data-vv-name="PESEL"
                  :error-messages="errors.collect('PESEL')"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="Imię"
                  v-model="formData.recipient_first_name"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="Nazwisko"
                  v-model="formData.recipient_last_name"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm8>
                <v-text-field
                  label="Ulica"
                  v-model="formData.recipient_street"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm2>
                <v-text-field
                  label="Nr budynku"
                  v-model="formData.recipient_building_no"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm2>
                <v-text-field
                  label="Nr lokalu"
                  v-model="formData.recipient_flat_no"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm4>
                <v-text-field
                  label="Kod pocztowy"
                  v-model="formData.recipient_postal_code"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm8>
                <v-text-field
                  label="Miasto"
                  v-model="formData.recipient_city"
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="subheading mb-1">Płatność</div>
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                  :items="meta.payment_methods"
                  label="Metoda płatności"
                  v-model="formData.payment_method"
                  item-text="label"
                  item-value="value"
                  v-validate="'required'"
                  data-vv-name="metoda płatności"
                  :error-messages="errors.collect('metoda płatności')"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 v-if="selectedMethodHasTerm">
                <v-autocomplete
                  :items="meta.payment_terms"
                  label="Termin płatności (dni)"
                  v-model="formData.payment_term_days"
                  item-text="label"
                  item-value="value"
                  v-validate="'required'"
                  data-vv-name="termin płatności"
                  :error-messages="errors.collect('termin płatności')"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12>
                <div class="subheading mb-1">Vouchery</div>
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  :items="availableVouchers"
                  v-model="formData.voucher_ids"
                  label="Wybierz vouchery"
                  item-text="voucher_number"
                  item-value="id"
                  multiple
                  chips
                  deletable-chips
                  :filter="() => true"
                  :search-input.sync="voucherSearch"
                  :error-messages="errors.collect('vouchers')"
                  @input="clearVoucherError"
                  browser-autocomplete="off"
                  no-data-text="Wpisz numer vouchera aby wyszukać"
                >
                  <template slot="item" slot-scope="{ item }">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        #{{ item.voucher_number }} — PLN {{ item.price }}
                        <span v-if="item.service_type"> — {{ item.service_type }}</span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 v-if="formData.voucher_ids && formData.voucher_ids.length">
                <div class="caption grey--text">
                  Szacowana kwota: PLN {{ estimatedAmount }}
                </div>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="$router.push({ name: 'DebitNotes' })">Anuluj</v-btn>
          <v-btn color="blue darken-1" flat :disabled="isProcessing" type="submit">Zapisz</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex';
  import { clearEmptyFields } from '../../helpers/clearEmptyFields';

  export default {
    name: 'CreateDebitNote',
    data() {
      return {
        open: true,
        isProcessing: false,
        gusLoading: false,
        issuedAtPicker: false,
        voucherSearch: null,
        voucherSearchTimeout: null,
        availableVouchers: [],
        meta: {
          payment_methods: [],
          payment_terms: [],
        },
        formData: {
          issued_at: new Date().toISOString().substr(0, 10),
          voucher_ids: [],
        },
      };
    },
    computed: {
      estimatedAmount() {
        if (!this.formData.voucher_ids || !this.formData.voucher_ids.length) return '0.00';
        const total = this.availableVouchers
          .filter(v => this.formData.voucher_ids.includes(v.id))
          .reduce((sum, v) => sum + Number(v.price || 0), 0);
        return total.toFixed(2);
      },
      selectedMethodHasTerm() {
        const method = (this.meta.payment_methods || [])
          .find(m => m.value === this.formData.payment_method);
        return !!(method && method.has_term);
      },
    },
    watch: {
      voucherSearch(val) {
        this.onVoucherSearch(val);
      },
      selectedMethodHasTerm(hasTerm) {
        // metoda bez odroczonego terminu (np. gotówka) nie ma terminu płatności
        if (!hasTerm) {
          this.formData.payment_term_days = null;
        }
      },
    },
    mounted() {
      this.loadMeta();
      this.loadAvailableVouchers('');
      const prefillId = Number(this.$route.query.voucher_id);
      if (prefillId) {
        this.fetchAvailableVoucher(prefillId)
          .then((voucher) => {
            if (!this.availableVouchers.some(v => v.id === voucher.id)) {
              this.availableVouchers = [voucher, ...this.availableVouchers];
            }
            this.formData.voucher_ids = [voucher.id];
          });
      }
    },
    methods: {
      ...mapActions('DebitNoteStore', ['fetchMeta', 'fetchAvailableVoucher', 'fetchAvailableVouchers', 'createNote']),
      ...mapActions('GusStore', ['searchCompany']),
      async fetchFromGus() {
        const nip = (this.formData.recipient_nip || '').replace(/[^0-9]/g, '');
        if (nip.length !== 10) {
          this.$validator.errors.add({ field: 'NIP', msg: 'Podaj poprawny NIP (10 cyfr).' });
          return;
        }
        this.gusLoading = true;
        try {
          const company = await this.searchCompany({ nip });
          this.$validator.errors.remove('NIP');
          this.applyGusCompany(company);
        } catch (e) {
          const msg = (e && e.response && e.response.data && e.response.data.message)
            ? e.response.data.message
            : 'Nie znaleziono podmiotu w GUS. Sprawdź poprawność NIP.';
          this.$validator.errors.add({ field: 'NIP', msg: msg });
        } finally {
          this.gusLoading = false;
        }
      },
      applyGusCompany(company) {
        const address = company.address || {};
        // reassign całości -> gwarantuje reaktywność Vue 2 dla pól dodawanych po fakcie
        this.formData = {
          ...this.formData,
          recipient_company_name: company.name,
          recipient_nip: company.nip,
          recipient_street: address.street,
          recipient_building_no: address.building_number,
          recipient_flat_no: address.flat_number,
          recipient_postal_code: address.postal_code,
          recipient_city: address.city || address.postal_city,
        };
      },
      loadAvailableVouchers(search) {
        return this.fetchAvailableVouchers({ search: search || '' })
          .then((response) => {
            const results = response.data || response;
            const selected = this.availableVouchers.filter(v => this.formData.voucher_ids.includes(v.id));
            const selectedIds = selected.map(v => v.id);
            this.availableVouchers = [...selected, ...results.filter(v => !selectedIds.includes(v.id))];
          });
      },
      loadMeta() {
        this.fetchMeta({ issued_at: this.formData.issued_at })
          .then((response) => {
            this.meta = response;
            if (response.next_number) {
              this.formData.number = response.next_number;
            }
          });
      },
      fetchMetaForDate() {
        this.fetchMeta({ issued_at: this.formData.issued_at })
          .then((response) => {
            if (response.next_number) {
              this.formData.number = response.next_number;
            }
            if (response.payment_methods) {
              this.meta.payment_methods = response.payment_methods;
            }
            if (response.payment_terms) {
              this.meta.payment_terms = response.payment_terms;
            }
          });
      },
      onVoucherSearch(val) {
        clearTimeout(this.voucherSearchTimeout);
        this.voucherSearchTimeout = setTimeout(() => {
          this.loadAvailableVouchers(val || '');
        }, 300);
      },
      validateRecipient() {
        // odbiorca: wymagany NIP albo (imię i nazwisko) — jak w StoreDebitNoteRequest::after()
        const hasNip = (this.formData.recipient_nip || '').replace(/\D/g, '').length === 10;
        const hasName = !!(this.formData.recipient_first_name && this.formData.recipient_last_name);
        if (!hasNip && !hasName) {
          this.$validator.errors.add({
            field: 'NIP',
            msg: 'Podaj NIP albo imię i nazwisko odbiorcy.',
          });
          return false;
        }
        return true;
      },
      validateVouchers() {
        if (!this.formData.voucher_ids || !this.formData.voucher_ids.length) {
          this.$validator.errors.add({ field: 'vouchers', msg: 'Dodaj przynajmniej jeden voucher.' });
          return false;
        }
        return true;
      },
      clearVoucherError() {
        this.$validator.errors.remove('vouchers');
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            const recipientValid = this.validateRecipient();
            const vouchersValid = this.validateVouchers();
            if (isValid && recipientValid && vouchersValid) {
              this.isProcessing = true;
              const formData = clearEmptyFields(Object.assign({}, this.formData));
              this.createNote(formData)
                .then(() => {
                  this.isProcessing = false;
                  this.$router.push({ name: 'DebitNotes' });
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>
